<template>
  <v-ons-page class="music-detail-page">
    <v-ons-toolbar>
      <div class="left"><v-ons-back-button></v-ons-back-button></div>
      <div class="center music-title">{{music.title}}</div>
      <div class="right"></div>
    </v-ons-toolbar>
    <v-ons-card>
      <label><span>メモ</span>
        <textarea class="textarea music-memo" rows="8" v-model="memo" @change="saveMemo"></textarea>
      </label>
      <p></p>
      <div>譜面 (外部サイト)</div>
      <table class="score-table">
        <tr>
          <th>SP(1P)</th>
          <th>SP(2P)</th>
          <th>DP</th>
        </tr>
        <tr v-for="difficulty in ['N', 'H', 'A', 'L']">
          <td v-for="style in ['1', '2', 'D']">
            <a :class="(url = getScoreUrl(music, style, difficulty)) ? '' : 'disabled'" :href="url" target="_blank">
              {{style === 'D' ? 'DP' : 'SP'}}{{difficulty}}
            </a>
          </td>
        </tr>
      </table>
    </v-ons-card>
  </v-ons-page>
</template>

<script>
  export default {
    name: 'music-detail-page',
    props: ['music'],
    data () {
      return {
        memo: ''
      }
    },
    methods: {
      getScoreUrl: function (music, style, difficulty) {
        let id = null
        if (difficulty === 'L') {
          if (music.l_id) {
            id = music.l_id
            difficulty = 'A'
          }
        } else {
          if (!music.no_score || !music.no_score.includes((style === 'D' ? 'DP' : 'SP') + difficulty)) {
            id = (music.tex_id ? music.tex_id : music.id)
          }
        }
        return id ? 'http://textage.cc/score/' + id + '.html?' + style + difficulty : null
      },
      saveMemo: function () {
        let memos = JSON.parse(localStorage.getItem('memos'))
        if (!memos) memos = {}
        memos[this.music.id] = {
          value: this.memo,
          updated_at: Date.now()
        }
        localStorage.setItem('memos', JSON.stringify(memos))
      },
      loadMemo: function () {
        let memos = JSON.parse(localStorage.getItem('memos'))
        if (!memos) memos = {}
        if (this.music.id in memos) {
          this.memo = memos[this.music.id].value
        }
      }
    },
    mounted: function () {
      this.loadMemo()
    }
  }
</script>

<style scoped>
  .ios .music-detail-page .toolbar__left, .ios .music-detail-page .toolbar__right {
    width: 32px;
  }

  .ios .music-detail-page .toolbar {
    justify-content: space-between;
  }

  .ios .music-detail-page .toolbar__center {
    flex-grow: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .music-memo {
    width: 100%;
  }

  .score-table {
    width: 100%;
    text-align: center;
    table-layout: fixed;
  }

  .score-table th {
    padding: 10px;
    font-weight: normal;
  }

  .score-table td {
    padding: 5px;
  }

  a.disabled {
    pointer-events: none;
    cursor: default;
    text-decoration: none;
    color: darkgray;
  }
</style>



// WEBPACK FOOTER //
// src/components/MusicDetailPage.vue